const duplicateTranslationKey = (key: string): string => key;

export const translationsDashboard_en_part1 = {
  loadingConversations: "Loading Conversations...",
  sidebarTitle: "Conversations",
  goToLivechat: "Go to livechat",
  livechatAvailable: "This conversation is available in livechat mode...",
  showFilters: "Show filters",
  hideFilters: "Hide filters",
  clearFilters: "Clear filters",
  remove: "Remove",
  refresh: "Refresh",
  filtersPanelTitle: "Filters",
  filtersPanelHint: "Narrow the list and search",
  quickFilters: "Quick filters",
  noToken: "Token not found",
  bugStatus: "Bug status",
  customerRating: "Customer rating",
  Tags: "Tags",
  Topic: "Topic",
  topicArchivedLabel: "archived",
  topicOtherOption: "Other",
  conversationSyncDelayed: "Updates delayed. Reconnecting…",
  uncategorized: "Uncategorized conversation",
  noConvoSelected: "Select a conversation to see details.",
  reported: "reported",
  report: "Report",
  internal: "internal",
  resolved: "resolved",
  suggestion: "suggestion",
  test_feedback: "test feedback",
  ai_report: "AI report",
  noStatus: "none",
  markResolved: "Mark as resolved",
  removeStatus: "Remove bug status",
  reportBug: "Report bug",
  reportInternalBug: "Report internal bug",
  reportSuggestion: "Report suggestion",
  reportCriticalBug: "Report critical bug",
  reportAdminBug: "Report admin bug",
  reportAiReport: "AI report",
  reportBugTooltip:
    "Use for ordinary bugs or unexpected behavior in the conversation or chatbot that should be logged.",
  reportInternalBugTooltip:
    "Use for issues mainly relevant to your team internally - typically not blocking end users.",
  reportCriticalBugTooltip: "Use for serious errors that block users or require quick action.",
  reportAdminBugTooltip:
    "Use for bugs in the dashboard or admin features (shown only as admin report type).",
  reportAiReportTooltip: "Use for reports filed by AI agents (visible only to administrators).",
  reportSuggestionTooltip: "Use for improvement ideas - not for defects or broken behavior.",
  critical_bug: "critical bug",
  admin_bug: "admin bug",
  userRating: "User rating",
  ratingFeedback: "Feedback",
  purchaseYes: "This user made a purchase.",
  purchaseNo: "This user did not make a purchase.",
  all: "All",
  date: "Date",
  conversationID: "Conversation ID",
  showBugReport: "Show bug report",
  hideBugReport: "Hide bug report",
  reportTypeOptions: "Choose report type or add comment",
  addCommentOrViewComments: "Add comment / View comments",
  translateButton: "Translate",
  translatingButton: "Translating...",
  selectLanguageOption: "Select language",
  thumbsUp: "Thumbs up",
  thumbsDown: "Thumbs down",
  unviewed: "Unviewed",
  markAsUnread: "Mark as unread",
  delete: "Delete",
  conversationActions: "Conversation actions",
  view: "View",
  dashboardView: "Dashboard view",
  chatbotView: "Chatbot view",
  chatbotViewLoading: "Loading chatbot view",
  chatbotViewLoadError: "Could not load the chatbot view.",
  chatbotViewRetry: "Try again",
  typeYourAnswer: "Type your answer here...",
  agentName: "Agent Name",
  saveAgentName: "Save Agent Name",
  previous: "Previous",
  next: "Next",
  agentNameLabel: "Your Agent Name",
  agentNamePlaceholder: "Enter your agent name",
  agentNameSaved: "Agent name saved!",
  searchConversationsPlaceholder: "Search conversations, IDs, or user IDs...",
  noConversationsMatchFilters: "No conversations match your filters.",
  noConversationsMatchFiltersHint:
    "Try clearing filters or searching for a conversation ID or user ID.",
  conversationsLoadFailed: "Conversations could not be loaded.",
  conversationsLoadFailedHint:
    "Try again. If it keeps failing, search fewer chatbots or a shorter period.",
  noMessages: "No messages yet",
  endOfList: "End of list",
  loadingMoreConversations: "Loading more conversations",
  pageLabel: "Page",
  userIDLabel: "User ID",
  ligegyldigLabel: "Meaningless",
  ligegyldigYes: "Yes",
  ligegyldigNo: "No",
  freshdeskFormVisualOnly: "This is only a visual representation of the contact form",
  addNotesPlaceholder: "Add notes here...",
  freshdeskContactSupport: "Contact customer service",
  freshdeskYourEmail: "Your email:",
  freshdeskEmailPlaceholder: "example@mail.com",
  freshdeskSupportMessage: "Message to customer service:",
  freshdeskMessagePlaceholder: "Write your message here...",
  freshdeskUploadImageOptional: "Upload image (optional):",
  freshdeskChooseFile: "Choose file",
  freshdeskNoFileChosen: "No file chosen",
  freshdeskSendInquiry: "Send inquiry",
  leadgenContactForm: "Contact Form",
  contactFormSubmitted: "Contact form submitted",
  originalFormDisplayUnavailable: "The original form display was not recorded for this message.",
  contactFormSubmittedDescription: "The customer completed the contact form below.",
  livechatHandoverSent: "Sent to live chat",
  livechatHandoverSentDescription: "The customer accepted the handover to a live agent.",
  livechatHandoverDeclined: "Live chat declined",
  livechatHandoverDeclinedDescription: "The customer declined the handover to a live agent.",
  livechatPromptQuestionPlaceholder: "Would you like to talk to an agent?",
  livechatPromptYesTextPlaceholder: "Yes please",
  livechatPromptNoTextPlaceholder: "No thanks",
  leadgenNameLabel: "Your Name",
  leadgenNamePlaceholder: "Enter your name",
  leadgenEmailLabel: "Your Email",
  leadgenEmailPlaceholder: "Enter your email",
  leadgenSubmitButton: "Submit",
  leadgenFormVisualOnly: "This form is for display purposes only in the dashboard",
  searchInfoChunks: "Search your info chunks...",
  selectOption: "Select the option",
  selectKnowledgebase: "Select knowledgebase",
  dateLabel: "Date",
  purchaseLabel: "Purchase",
  [duplicateTranslationKey("purchaseNo")]: "No purchase",
  withPurchase: "With Purchase",
  testConversationsFilter: "Test",
  missingInfo: "Missing Info",
  missingInfoFilterApplied: "Showing conversations with missing info",
};
